import * as AWS from 'aws-sdk';

import {Inject, Injectable} from "@angular/core";
import {Router} from "@angular/router";
import {UrlUtils} from "./url.utils";
import {ConfigurationService} from "../services/configuration.service";
import {GlobalConstants} from "../common/global-constants";
import {S3} from "aws-sdk";

@Injectable()
export class S3Utils {

  private awsIdentityPoolIdRegion: string;
  private s3Client: AWS.S3;

  constructor(
    private readonly router: Router,
    @Inject('UrlUtils') private readonly urlUtils: UrlUtils,
    @Inject('ConfigurationService') private readonly configurationService: ConfigurationService
  ) {
    configurationService.getSettings().subscribe(settings => {
      this.awsIdentityPoolIdRegion = settings.awsIdentityPoolIdRegion;
    });
    AWS.config.region = this.awsIdentityPoolIdRegion;
    this.s3Client = new AWS.S3({apiVersion: '2006-03-01'});
  }

  async  getAllKeys(params,  allKeys = []){
    if ((<AWS.CognitoIdentityCredentials>AWS.config.credentials).needsRefresh()) {
      (<AWS.CognitoIdentityCredentials>AWS.config.credentials).refresh((error) => {
        if (error != null) {
          console.log("Error while refreshing credentials: " + error.message);
        }
      });
    }
    const response = await this.s3Client.listObjectsV2(params).promise();
    response.Contents.forEach(obj => allKeys.push(obj));

    if (response.NextContinuationToken) {
      params.ContinuationToken = response.NextContinuationToken;
      await this.getAllKeys(params, allKeys);
    }
    return allKeys;
  }

  async getAllS3FilePath(bucketName): Promise<string[]> {
    let bucketParams = {
      Bucket: bucketName
    };
    console.log("Fetching Business Uploaded S3 File Paths with Parameter ", bucketParams)
    const allKeys = await this.getAllKeys(bucketParams);
    console.log("Total unfiltered keys ", allKeys.length)
    return this.filterS3PathObject(allKeys)
  }


  private filterS3PathObject(allS3PathObject :  S3.Object[]) : string[] {

    let s3KeyObjectList = allS3PathObject.map(s3Object => {
      return {
        Key : s3Object.Key.split(GlobalConstants.SLASH).slice(GlobalConstants.ZERO, -1).join(GlobalConstants.SLASH),
        LastModified : s3Object.LastModified
      }
    })

    /*
    As business uploaded file will be in multiple parts
    so displaying file until second last level( last level will contain path to part files).
     */
    let s3KeySet = new Set()
    let filteredS3ObjectList = []
    s3KeyObjectList.forEach(s3KeyObject => {
      if(!s3KeySet.has(s3KeyObject.Key)){
        filteredS3ObjectList.push(s3KeyObject)
        s3KeySet.add(s3KeyObject.Key)
      }
    })
    filteredS3ObjectList.sort((s3PathObject1, s3PathObject2) => {
      return s3PathObject2.LastModified.getTime() - s3PathObject1.LastModified.getTime();
    });
    let finalKeys = filteredS3ObjectList.slice(GlobalConstants.ZERO, GlobalConstants.NUMBER_OF_RECENT_UPLOADED_FILES).map(s3KeyObject => s3KeyObject.Key).filter(key => key)
    console.log("Total filtered keys ", finalKeys.length)
    return finalKeys
  }
}
